import React from "react";
import { FaHeart, FaShoppingCart } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { addToCart } from "../../features/cart/cartSlice";

function ProductCard({ product, isFavorite, onToggleFavorite }) {
  const dispatch = useDispatch();

  // 🛒 إضافة إلى السلة عبر Redux
  const handleAddToCart = () => {
    dispatch(addToCart(product));
    Swal.fire({
      icon: "success",
      title: "Added to Cart 🛒",
      text: `${product.name} has been added to your cart.`,
      showConfirmButton: false,
      timer: 2000,
    });
  };

  // ❤️ المفضلة
  const handleFavoriteClick = () => {
    onToggleFavorite();
    Swal.fire({
      icon: isFavorite ? "info" : "success",
      title: isFavorite ? "Removed from Favorites" : "Added to Favorites",
      text: `${product.name} ${
        isFavorite ? "removed from" : "added to"
      } your favorites.`,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  return (
    <div className="col-md-4 col-lg-3 mb-4">
      <div className="card h-100 shadow-sm rounded-3 p-3">
        <img
          src={product.image}
          className="card-img-top rounded-3"
          alt={product.name}
          style={{ height: "200px", objectFit: "cover" }}
        />
        <div className="card-body text-center">
          <h5 className="card-title">
            <Link
              to={`/product/${product.id}`}
              style={{ textDecoration: "none", color: "#2f6579" }}
            >
              {product.name}
            </Link>
          </h5>

          <p className="card-text text-muted">${product.price}</p>

          <div className="d-flex justify-content-between align-items-center">
            {/* 🛒 Add to Cart */}
            <button
              className="btn add-to-cart d-flex align-items-center gap-2"
              style={{
                backgroundColor: "#2f6579",
                color: "white",
                transition: "all 0.3s ease",
              }}
              onClick={handleAddToCart}
              onMouseDown={(e) =>
                (e.currentTarget.style.transform = "scale(0.95)")
              }
              onMouseUp={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <FaShoppingCart />
              Add to Cart
            </button>

            {/* ❤️ Favorite */}
            <FaHeart
              size={22}
              onClick={handleFavoriteClick}
              style={{
                cursor: "pointer",
                color: isFavorite ? "red" : "gray",
                transition: "0.3s",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
